<template>
	<Modal @close="$emit('close')" size="small">
		<div class="container">
			<div class="row">
				<div class="col-12">
					<h3>Edit {{ age.text }}</h3>
				</div>
			</div>
			<Form :age="age" @close="$emit('close')"/>
		</div>
	</Modal>
</template>

<script>
import Modal from './../Modal.vue'
import Form from './Form.vue'

export default {
	components: {
		Modal,
		Form
	},
	props: [
		'age'
	]
}
</script>

<style lang="scss">

</style>


// WEBPACK FOOTER //
// src/components/Age/Edit.vue